import { Dialog, DialogTitle, Typography } from "@material-ui/core"
import UpdateAdminForm from "components/Forms/UpdateAdminForm"
import AppContext from "contexts/App"
import { useContext } from "react"

import useStyles from "./styles"

const UpdateAdmin = () => {
  const classes = useStyles()

  const { dialogs, closeDialog } = useContext(AppContext)
  const thisDialog = dialogs?.["updateAdmin"] || {}
  const { open = false, data = {} } = thisDialog
  let user = thisDialog?.data?.user
  let tableRef = thisDialog?.data?.tableRef
  const handleClose = () => {
    closeDialog("updateAdmin")
  }

  return (
    <Dialog open={open} classes={{ paperWidthSm: classes.paper }}>
      <DialogTitle disableTypography>
        <Typography variant="h2">Update Admin</Typography>
        <UpdateAdminForm
          handleClose={handleClose}
          user={user}
          tableRef={tableRef}
        />
      </DialogTitle>
    </Dialog>
  )
}

export default UpdateAdmin
